import React from 'react';
import PropTypes from 'prop-types';
import styles from './GiftDetailDialog.module.scss';
import CardGiftcardRoundedIcon from '@material-ui/icons/CardGiftcardRounded';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { toast } from 'react-toastify';
import { useTranslation } from '../../i18n/LanguageProvider';

const GiftDetailDialog = (props) => {
  const { t } = useTranslation();
  const copyToClipboard = () => {
    navigator.clipboard.writeText('JDSH0923VNXPZ9D');
    toast.success(t('rewards.codeCopied'));
  };

  return (
    <div className={styles.wrapper}>
      {props.data.photo ? (
        <img
          src={props.data.photo.thumbnail}
          alt={'photo of ' + props.data.title}
          className={styles.thumbnail}
        />
      ) : (
        <CardGiftcardRoundedIcon style={{ fontSize: '3.5rem' }} />
      )}
      <div className={styles.category}>{props.data.category.title}</div>
      <div className={styles.title}>{props.data.title}</div>
      <div className={styles.desc}>{props.data.description}</div>
      <div className={styles.bottomWrapper}>
        {props.isOwned ? (
          <span onClick={copyToClipboard} className={styles.code}>
            JDSH0923VNXPZ9D
            <FileCopyIcon />
          </span>
        ) : (
          <>
            <div className={styles.price}>{props.data.coin}</div>
            <div className={styles.available}>{props.data.stock}</div>
          </>
        )}
      </div>
    </div>
  );
};

GiftDetailDialog.propTypes = {
  data: PropTypes.object,
  isOwned: PropTypes.bool
};

export default GiftDetailDialog;
